import { FooterHelp, Link } from "@shopify/polaris"
import React from "react"
import { Trans } from "react-i18next"

export default function FooterLink() {
  return (
    <FooterHelp>
      <Trans i18nKey="LearnMoreAboutParcelWILLByCWILL">
        <Link
          removeUnderline
          external
          url="https://www.parcelwill.com/products/returns-exchanges/"
        >
          ParcelWILL
        </Link>
        <Link
          removeUnderline
          external
          url="https://www.channelwill.com/parcelpanel-returns/"
        >
          CWILL
        </Link>
      </Trans>
    </FooterHelp>
  )
}
